module.exports = __webpack_public_path__ + "static/media/bet-logo-singapore-pools.ad1b80d9.png";